import React, { useEffect, useState, useCallback } from "react";
import Layout from "../Layout";
import { Button, Switchi, Textarea } from "../components/Form"; // Removemos Input import
import { HiOutlineCheckCircle } from "react-icons/hi";
import { FaDownload } from "react-icons/fa";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllConfiguration,
  getConfiguration,
  getConfigurationStatus,
  updateConfiguration,
} from "../redux/features/configurationSlice";
import { useForm } from "react-hook-form";
import TwoColumRow from "../components/TwoColumRow";
import ThreeColumRow from "../components/ThreeColumRow";
import MultiSelect from "../components/MultiSelect";
import ConfirmationAlert from "../components/ConfirmationAlert";
import Loading from "./Loading";
import { BsArrowUpRightSquareFill } from "react-icons/bs";
import ChangePasswordModal from "../components/Modals/ChangePasswordModal";
import { selectCurrentUser } from "../redux/features/authSlice";
import { apiUrl } from "../redux/apiUrl";

const options = [
  { id: "tiempo1", name: "30 minutos" },
  { id: "tiempo2", name: "1 hora" },
  { id: "tiempo3", name: "3 horas" },
  { id: "tiempo4", name: "6 horas" },
  { id: "tiempo5", name: "12 horas" },
  { id: "tiempo6", name: "1 día" },
  { id: "tiempo7", name: "2 días" },
  { id: "tiempo8", name: "1 semana" },
  { id: "tiempo9", name: "1 mes" },
];

// Función para formatear logs frontend para descarga
const formatFrontendLogsForDownload = (logs) => {
  return logs
    .map(
      (log) =>
        `[${new Date(
          log.created_at
        ).toLocaleString()}] [${log.level?.toUpperCase()}] ${log.message}
URL: ${log.url || "N/A"}
Usuario: ${log.user ? log.user.name || log.user.email : "N/A"}
Navegador: ${log.browser || "N/A"} on ${log.os || "N/A"}
IP: ${log.ip_address || "N/A"}
Archivo: ${log.file || "N/A"}:${log.line || "N/A"}
${
  log.additional_data
    ? `Datos adicionales: ${JSON.stringify(log.additional_data, null, 2)}`
    : ""
}
${log.stack_trace ? `Stack Trace: ${log.stack_trace}` : ""}
======================================================
`
    )
    .join("\n");
};

// Función para formatear logs API para descarga - CORREGIDA
const formatApiLogsForDownload = (logs) => {
  return logs
    .map(
      (log) =>
        `[${new Date(log.created_at).toLocaleString()}] [${log.method}] ${
          log.endpoint
        }
Código de estado: ${log.status_code || "N/A"}
Datos de solicitud: ${
          typeof log.request_data === "string"
            ? log.request_data
            : JSON.stringify(log.request_data || {}, null, 2)
        }
Datos de respuesta: ${
          typeof log.response_data === "string"
            ? log.response_data
            : JSON.stringify(log.response_data || {}, null, 2)
        }
======================================================
`
    )
    .join("\n");
};

// Función para descargar archivo
const downloadFile = (content, filename) => {
  const blob = new Blob([content], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Componente Input personalizado para evitar el error
const CustomInput = ({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  ...props
}) => {
  return (
    <div>
      {label && (
        <label className="block text-sm font-medium mb-2">{label}</label>
      )}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
        {...props}
      />
    </div>
  );
};

function Settings() {
  const [selected, setSelected] = useState([]);
  const [sistema, setSistema] = useState(false);
  const [mail, setMail] = useState(false);
  const [openLoginData, setOpenLoginData] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [logType, setLogType] = useState("frontend");
  const [apiFilters, setApiFilters] = useState({
    endpoint: "",
    method: "",
    status_code: "",
  });

  const dispatch = useDispatch();
  const configuration = useSelector(getAllConfiguration);
  const status = useSelector(getConfigurationStatus);
  const user = useSelector(selectCurrentUser);

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  // Función reutilizable para obtener logs del servidor
  const fetchLogs = useCallback(
    async (urlParams = {}) => {
      const token = localStorage.getItem("auth_token");
      const params = new URLSearchParams({
        per_page: 500,
        sort: "desc",
        type: logType,
        ...urlParams,
        ...(logType === "api" &&
          apiFilters.endpoint && { endpoint: apiFilters.endpoint }),
        ...(logType === "api" &&
          apiFilters.method && { method: apiFilters.method }),
        ...(logType === "api" &&
          apiFilters.status_code && { status_code: apiFilters.status_code }),
      }).toString();

      const url = `${apiUrl}/api/v1/logs?${params}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`HTTP ${response.status}: ${errorText}`);
        }

        const data = await response.json();
        return data.data || [];
      } catch (error) {
        console.error("Error fetching logs:", error);
        throw error;
      }
    },
    [apiUrl, logType, apiFilters]
  );

  // Función para descargar logs con diferentes filtros
  const downloadLogs = useCallback(
    async (filterType, filterValue = null) => {
      setDownloading(true);
      try {
        let urlParams = {};
        let filename = "";

        switch (filterType) {
          case "period":
            if (filterValue) {
              const dateFrom = new Date();
              dateFrom.setDate(dateFrom.getDate() - filterValue);
              urlParams.date_from = dateFrom.toISOString().split("T")[0];
              filename = `logs_${logType}_ultimos_${filterValue}_dias_${
                new Date().toISOString().split("T")[0]
              }.txt`;
            } else {
              filename = `logs_${logType}_completos_${
                new Date().toISOString().split("T")[0]
              }.txt`;
            }
            break;
          case "level":
            urlParams.level = filterValue;
            filename = `logs_${logType}_${filterValue}_${
              new Date().toISOString().split("T")[0]
            }.txt`;
            break;
          default:
            filename = `logs_${logType}_${
              new Date().toISOString().split("T")[0]
            }.txt`;
        }

        const logs = await fetchLogs(urlParams);

        // Elegir el formateador según el tipo de log
        const logContent =
          logType === "api"
            ? formatApiLogsForDownload(logs)
            : formatFrontendLogsForDownload(logs);

        downloadFile(logContent, filename);

        toast.success(
          filterType === "level"
            ? `Logs de nivel ${filterValue} descargados`
            : filterValue
            ? `Logs de los últimos ${filterValue} días descargados`
            : `Todos los logs ${logType} descargados`
        );
      } catch (error) {
        console.error("Error downloading logs:", error);
        toast.error("Error al descargar logs: " + error.message);
      } finally {
        setDownloading(false);
      }
    },
    [fetchLogs, logType]
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(getConfiguration());
    }

    if (configuration && typeof configuration === "object") {
      const fields = [
        "complet_name",
        "printer_name",
        "specialty",
        "email",
        "password",
        "email_secretaria",
        "port",
        "host",
        "template",
        "mailer",
      ];

      fields.forEach((field) => {
        if (configuration[field] !== undefined) {
          setValue(field, configuration[field]);
        }
      });

      const newSelected = options.filter(
        (option) => configuration[option.id] === true
      );
      setSelected(newSelected);

      setSistema(configuration.notificacion_system || false);
      setMail(configuration.notificacion_email || false);
    }
  }, [dispatch, configuration, status, setValue]);

  const onSubmit = (body) => {
    ConfirmationAlert({
      title: "Guardar Configuración",
      text: "¿Está seguro de guardar la configuración?",
      onAccept: () => {
        options.forEach((option) => {
          body[option.id] = selected.includes(option);
        });

        body.notificacion_system = sistema;
        body.notificacion_email = mail;

        dispatch(updateConfiguration(body));
      },
    });
  };

  const handleApiFilterChange = (field, value) => {
    setApiFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <Layout>
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-semibold">Configuración</h1>

        <button
          onClick={() => downloadLogs("period", 7)}
          disabled={downloading}
          className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md flex items-center gap-2 disabled:opacity-50"
        >
          <FaDownload />
          {downloading ? "Descargando..." : "Descargar Logs"}
        </button>
      </div>

      {status === "loading" ? (
        <Loading />
      ) : (
        <div className="flex flex-col items-center">
          <ChangePasswordModal
            open={openLoginData}
            setOpen={setOpenLoginData}
            username={user?.username}
          />

          <div className="flex flex-col gap-2 mt-2 w-full max-w-[48rem] bg-white p-8 rounded-xl border">
            <h1 className="text-2xl font-semibold">
              Configuración de parámetros del doctor
            </h1>

            <ThreeColumRow>
              <input
                {...register("complet_name")}
                placeholder="Nombre Completo"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                {...register("printer_name")}
                placeholder="Nombre de impresión"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                {...register("specialty")}
                placeholder="Especialidad"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
            </ThreeColumRow>

            <TwoColumRow>
              <input
                {...register("email", {
                  pattern: {
                    value: /\S+@\S+\.\S+/,
                    message: "No coincide con el formato de correo electrónico",
                  },
                })}
                placeholder="Email"
                type="email"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                {...register("password")}
                placeholder="Password"
                type="text"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
            </TwoColumRow>

            <ThreeColumRow>
              <input
                {...register("host")}
                placeholder="Host"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                {...register("mailer")}
                placeholder="Mailer"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                {...register("port")}
                placeholder="Puerto"
                type="number"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
            </ThreeColumRow>

            <p>Tiempo Antes de cada Notificación</p>
            <MultiSelect
              options={options}
              value={selected}
              setSelected={setSelected}
              placeholder="Notificaciones antes de la cita ..."
            />

            <div className="flex items-center gap-4 my-2">
              <p>Datos de Inicio de Sesión</p>
              <button
                onClick={() => setOpenLoginData(true)}
                className="hover:text-black text-yellow-400 font-bold bg-none rounded-md flex items-center justify-center text-md"
                style={{ width: "18p", height: "18px" }}
                title="Mostrar datos de inicio de sesión"
              >
                <BsArrowUpRightSquareFill size={18} />
              </button>
            </div>

            <TwoColumRow>
              <input
                {...register("email_secretaria", {
                  pattern: {
                    value: /\S+@\S+\.\S+/,
                    message: "No coincide con el formato de correo electrónico",
                  },
                })}
                placeholder="Email Secretaria"
                type="email"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
              <div className="mt-8 p-3 border rounded-xl">
                <TwoColumRow>
                  <Switchi checked={mail} label="Email" onChange={setMail} />
                  <Switchi
                    checked={sistema}
                    label="Web"
                    onChange={setSistema}
                  />
                </TwoColumRow>
              </div>
            </TwoColumRow>

            <Textarea
              register={register("template", {
                required: "El motivo de la cita es requerido.",
              })}
              name="template"
              setValue={setValue}
              getValue={getValues}
              label="Template de mensaje Email"
              placeholder="El template debe estar en formato html"
              color={true}
              rows={5}
            />

            <Button
              label={"Guardar parámetros"}
              Icon={HiOutlineCheckCircle}
              onClick={handleSubmit(onSubmit)}
            />
          </div>

          {/* Sección de descarga de logs */}
          <div className="mt-6 w-full max-w-[48rem] bg-white p-6 rounded-xl border">
            <h2 className="text-xl font-semibold mb-4">
              Gestión de Logs del Sistema
            </h2>

            {/* Selector de tipo de logs */}
            <div className="mb-4">
              <label className="block text-sm font-medium mb-2">
                Tipo de Logs:
              </label>
              <select
                value={logType}
                onChange={(e) => setLogType(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="frontend">Logs Frontend</option>
                <option value="api">Logs API</option>
              </select>
            </div>

            {/* Filtros específicos para logs API */}
            {logType === "api" && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4 p-3 bg-gray-50 rounded-lg">
                <CustomInput
                  label="Endpoint"
                  placeholder="Filtrar por endpoint"
                  value={apiFilters.endpoint}
                  onChange={(e) =>
                    handleApiFilterChange("endpoint", e.target.value)
                  }
                />
                <div>
                  <label className="block text-sm font-medium mb-2">
                    Método HTTP
                  </label>
                  <select
                    value={apiFilters.method}
                    onChange={(e) =>
                      handleApiFilterChange("method", e.target.value)
                    }
                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">Todos los métodos</option>
                    <option value="GET">GET</option>
                    <option value="POST">POST</option>
                    <option value="PUT">PUT</option>
                    <option value="DELETE">DELETE</option>
                    <option value="PATCH">PATCH</option>
                  </select>
                </div>
                <CustomInput
                  label="Código de Estado"
                  placeholder="Ej: 200, 404, 500"
                  type="number"
                  value={apiFilters.status_code}
                  onChange={(e) =>
                    handleApiFilterChange("status_code", e.target.value)
                  }
                />
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <h3 className="font-medium mb-2">Descargar por período</h3>
                <div className="grid grid-cols-2 gap-2">
                  <button
                    onClick={() => downloadLogs("period", 1)}
                    disabled={downloading}
                    className="bg-green-600 hover:bg-green-700 text-white py-2 px-3 rounded text-sm disabled:opacity-50"
                  >
                    Último día
                  </button>
                  <button
                    onClick={() => downloadLogs("period", 7)}
                    disabled={downloading}
                    className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-3 rounded text-sm disabled:opacity-50"
                  >
                    7 días
                  </button>
                  <button
                    onClick={() => downloadLogs("period", 30)}
                    disabled={downloading}
                    className="bg-yellow-600 hover:bg-yellow-700 text-white py-2 px-3 rounded text-sm disabled:opacity-50"
                  >
                    30 días
                  </button>
                  <button
                    onClick={() => downloadLogs("period")}
                    disabled={downloading}
                    className="bg-red-600 hover:bg-red-700 text-white py-2 px-3 rounded text-sm disabled:opacity-50"
                  >
                    Todos
                  </button>
                </div>
              </div>

              {/* Filtros por nivel solo para logs frontend */}
              {logType === "frontend" && (
                <div>
                  <h3 className="font-medium mb-2">Descargar por tipo</h3>
                  <div className="grid grid-cols-2 gap-2">
                    <button
                      onClick={() => downloadLogs("level", "error")}
                      disabled={downloading}
                      className="bg-red-600 hover:bg-red-700 text-white py-2 px-3 rounded text-sm disabled:opacity-50"
                    >
                      Errores
                    </button>
                    <button
                      onClick={() => downloadLogs("level", "warning")}
                      disabled={downloading}
                      className="bg-yellow-600 hover:bg-yellow-700 text-white py-2 px-3 rounded text-sm disabled:opacity-50"
                    >
                      Advertencias
                    </button>
                    <button
                      onClick={() => downloadLogs("level", "info")}
                      disabled={downloading}
                      className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-3 rounded text-sm disabled:opacity-50"
                    >
                      Información
                    </button>
                    <button
                      onClick={() => downloadLogs("level", "debug")}
                      disabled={downloading}
                      className="bg-gray-600 hover:bg-gray-700 text-white py-2 px-3 rounded text-sm disabled:opacity-50"
                    >
                      Debug
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="bg-gray-50 p-3 rounded-lg">
              <h4 className="font-medium mb-2">
                Información sobre los logs{" "}
                {logType === "api" ? "API" : "Frontend"}:
              </h4>
              <ul className="text-sm text-gray-600 space-y-1">
                {logType === "api" ? (
                  <>
                    <li>• Registros de endpoints y llamadas API</li>
                    <li>
                      • Incluyen método HTTP, endpoint y códigos de estado
                    </li>
                    <li>• Datos de request y response en formato JSON</li>
                    <li>• Útiles para debugging de APIs y monitorización</li>
                  </>
                ) : (
                  <>
                    <li>• Logs de errores y actividad del frontend</li>
                    <li>• Incluyen timestamp, nivel, mensaje y metadata</li>
                    <li>• Información de navegador, OS y ubicación</li>
                    <li>• Útiles para debugging de la aplicación web</li>
                  </>
                )}
              </ul>
            </div>

            {downloading && (
              <div className="mt-3 p-2 bg-blue-50 text-blue-700 rounded text-center">
                <span className="animate-pulse">
                  ⏳ Descargando logs {logType}...
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </Layout>
  );
}

export default Settings;
